import styled from 'styled-components'

export const Wrapper = styled.div`
  text-align: right;
  button {
    height: 40px;
    padding: 0 12px;
    margin-left: 8px;
    border-radius: 8px;
    border: none;
    font-weight: 700;
    color: #4c4c4c !important;
    background-color: #f0f0f0 !important;
    &:disabled {
      opacity: 0.7;
    }
  }
  button + button {
    color: white !important;
    background-color: #0085ff !important;
  }
`
